import { render } from "./ProductOverviewSection.vue?vue&type=template&id=3438159a&scoped=true"
import script from "./ProductOverviewSection.vue?vue&type=script&lang=js"
export * from "./ProductOverviewSection.vue?vue&type=script&lang=js"

import "./ProductOverviewSection.vue?vue&type=style&index=0&id=3438159a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3438159a"]])

export default __exports__